import React, { Component } from 'react';
import logo from '../public/pp.png';
import ContentPopper from './components/Poppers/ContentPopper.js';
import Background from './components/Background/Background.js';
import './App.css';

class App extends Component {
  render() {
    return (
      <div className="App">
        <div id="Highlight" className="Highlight">
          <img src={logo} className="App-logo" alt="logo"/>
          <div id="Social" className="Social">
            <a className="fa fa-facebook" aria-hidden="true" target="_blank" href="https://www.facebook.com/yubilimkurgu"></a>
            <a className="fa fa-instagram" aria-hidden="true" target="_blank" href="https://www.instagram.com/yeditepebilimkurgu"></a>
            <a className="fa fa-wikipedia-w" aria-hidden="true" target="_blank" href="http://yubkk.wikia.com/wiki/YUBKK_Wikia"></a>
          </div>
        </div>
        <Background/>
        <div className="Container">
          <ContentPopper name="BoardgamesPopper" header="Kutu Oyunlar"/>
          <ContentPopper name="RoleplayPopper" header="Roleplay"/>
          <ContentPopper name="CulturePopper" header="Kültür"/>
        </div>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js